import { IGoal } from 'motw_core/Entity/IGoal';

const GetGoalColor = (isUpper: boolean) => {
    if (!isUpper) {
        return "#40ff40";
    }

    if (isUpper) {
        return "#ff9700";
    }
    
    return "#878787";
};

export default GetGoalColor;

export const RemoveJsonServerGoals = (elem: IGoal) => elem.icon;